import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

const VideoModal = ({ url }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {t} = useTranslation()

  const openVideoModal = (youtubeUrl) => {
    const videoId =
      youtubeUrl.split("v=")[1]?.split("&")[0] ||
      youtubeUrl.split("/").pop()?.split("?")[0];
    setSelectedVideo(videoId);
    setIsModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  return (
    <>
      <button
        className={styles.videoButton}
        type="button"
        onClick={() => openVideoModal(url)}
      >
        ▶ {t('video')}
      </button>

      {/* YouTube Video Modal */}
      {isModalOpen && selectedVideo && (
        <Modal onClose={closeVideoModal}>
          <iframe
            width="800"
            height="450"
            src={`https://www.youtube.com/embed/${selectedVideo}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Modal>
      )}
    </>
  )
}

const Modal = ({ children, onClose }) => {
  const [container] = useState(() => document.createElement("div"));

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return createPortal(
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>×</button>
        {children}
      </div>
    </div>,
    container
  );
};

export default VideoModal